/*********************
Pass 2: Frustration Score
*********************/
import { interventionTypes, interventionSituationTypes } from '../../constants';

// Generates a current frustration score based on activity history
export default function getFrustrationScoreForRun(state, PASS_CONFIGS) {
  const {
    FRUSTRATION_interventionDelta,
    FRUSTRATION_wordInterventionDelta,
    FRUSTRATION_noInterventionDelta,
  } = PASS_CONFIGS.scorePass2;

  // Go through the activity history, incrementing and decrementing frustration
  let frustration = 0;
  state.interventionHistoryByPhrase.forEach(phraseInterventions => {
    // Filter out "none" interventions
    let filteredPhraseInterventions = phraseInterventions.filter(intervention => {
      return intervention.type != interventionTypes.none;
    });
    let numInterventions = filteredPhraseInterventions.length;
    if(numInterventions > 0) {
      filteredPhraseInterventions.forEach(intervention => {
        if(intervention.situation != interventionSituationTypes.PHRASE) {
          frustration += FRUSTRATION_wordInterventionDelta;
        } else {
          frustration += FRUSTRATION_interventionDelta;
        }
      });
    } else {
      frustration += FRUSTRATION_noInterventionDelta;
    }
  });
  state.scores.frustration = frustration;
}